import classNames from "classnames";
import * as ColumnType from "./ColumnType";
import * as ColumnAlignment from "./ColumnAlignment";
const columnTypeClassNames = {
  [ColumnType.SELECTION]: "selection",
  [ColumnType.ACTIONS]: "actions",
};
const columnAlignmentClassNames = {
  [ColumnAlignment.CENTER]: "text-center",
  [ColumnAlignment.RIGHT]: "text-right",
};
export function getCellClassName(column, baseClassName, applyAlignment = false) {
  const columnTypeClassName = columnTypeClassNames[column.type];
  const columnAlignmentClassName = applyAlignment && columnAlignmentClassNames[column.alignment];
  return classNames(baseClassName, columnTypeClassName, columnAlignmentClassName) || undefined; // Nechceme vrátit prázdný string
}
